'use client';

import { zzimcarToastAtom } from '@/atom/modal';
import { useAtom } from 'jotai';
import { useEffect, useMemo, useState } from 'react';

const RENDERING_TIME = 2000;

export default function ZzimcarToast() {
  const [zzimcarToast, setZzimcarToast] = useAtom(zzimcarToastAtom);
  const [animationType, setAnimationType] = useState<'toast-in' | 'toast-out'>();

  const renderingTime = useMemo(() => zzimcarToast?.renderingTime ?? RENDERING_TIME, [zzimcarToast?.renderingTime]);

  const toastStyle = useMemo(() => {
    const toastType = zzimcarToast?.type || 'info';

    switch (toastType) {
      case 'error':
        return {
          bg: 'bg-new-red-100',
          text: 'text-new-red-500',
        };
      case 'info':
      default:
        return {
          bg: 'bg-new-green-100',
          text: 'text-new-green-500',
        };
    }
  }, [zzimcarToast?.type]);

  useEffect(() => {
    if (animationType === 'toast-out') return;

    const fadeoutTimeout = setTimeout(() => setAnimationType('toast-out'), renderingTime);

    return () => {
      clearTimeout(fadeoutTimeout);
    };
  }, [animationType, renderingTime]);

  useEffect(() => {
    if (animationType === 'toast-in') return;
    const FADE_TIME = 200;

    const resetTextTimeout = setTimeout(() => {
      setZzimcarToast(null);
    }, renderingTime + FADE_TIME);

    return () => clearTimeout(resetTextTimeout);
  }, [animationType, renderingTime, setZzimcarToast]);

  useEffect(() => {
    if (!zzimcarToast) return;
    setAnimationType('toast-in');
  }, [zzimcarToast]);

  if (!zzimcarToast) return null;

  return (
    <div
      className={`fixed flex flex-col items-center -translate-x-1/2 left-1/2 bottom-80pxr px-16pxr py-12pxr w-[88%] max-w-420pxr gap-8pxr rounded-8pxr ${animationType} z-[9999] ${toastStyle.bg}`}
    >
      <p className={`text-center text-14pxr font-normal ${toastStyle.text} whitespace-pre-line`}>{zzimcarToast.text}</p>
    </div>
  );
}
